import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export type TriggerCrmSyncParams = {
  integrationId: string;
};

export const triggerCrmSync = async (
  params: TriggerCrmSyncParams,
): Promise<void> => {
  return await tinctApi.crmSync.triggerSync(params.integrationId);
};

export const useTriggerCrmSync = (
  options?: Omit<
    UseMutationOptions<void, ApiError, TriggerCrmSyncParams>,
    'mutationFn'
  >,
) => {
  const { onSettled, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: triggerCrmSync,
    // Settle (not success): even a failed trigger should refresh the rows —
    // a sync may have run server-side regardless.
    onSettled: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['ads-campaigns', args[2].integrationId],
      });
      queryClient.invalidateQueries({ queryKey: ['crm-integrations'] });
      onSettled?.(...args);
    },
    ...restOptions,
  });
};
